import ProductDrink from "./ProductDrink";

export default ProductDrink;
